import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin.js';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

export const numbers = () => {
  const spinElements = document.querySelectorAll('.spin, .js-num');

  if (spinElements.length === 0) return;
  
  spinElements.forEach(element => {
    // テキストの値を最終値として取得（カンマを含んだ状態で保持）
    const originalText = element.textContent;
    // 計算用に数値のみを取得
    const finalValue = parseFloat(element.textContent.replace(/,/g, ''));
    const min = parseFloat(element.dataset.countMin) || 0;
    const max = parseFloat(element.dataset.countMax) || finalValue;
    
    // 元の値に小数点が含まれているかチェック
    const hasDecimal = element.textContent.includes('.');
    // カンマが含まれているかチェック
    const hasComma = element.textContent.includes(',');
    // 小数点以下の桁数を取得（小数点がない場合は0、ある場合は1）
    const decimals = hasDecimal ? 1 : 0;
    
    // 必ず最小値からスタート
    element.textContent = formatNumber(min, decimals, hasComma);
    
    ScrollTrigger.create({
      trigger: element,
      start: 'top 80%',
      once: true,
      onEnter: () => {
        gsap.timeline({
          defaults: {
            ease: "power2.inOut",
            modifiers: {
              innerText: value => {
                element.style.width = 'auto';
                element.style.display = 'inline-block';
                return formatNumber(value, decimals, hasComma);
              }
            }
          }
        })
        .to(element, {
          duration: 1.2,
          innerText: max,
          snap: { innerText: 1 }
        })
        .to(element, {
          duration: 0.8,
          innerText: finalValue,
          snap: { innerText: 1 }
        });
      }
    });
  });
};

// 数値のフォーマット関数を改善
const formatNumber = (value, decimals, useComma = false) => {
  // カンマを使用する場合
  if (useComma) {
    const parts = Number(value).toFixed(decimals).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  }
  // カンマを使用しない場合
  return Number(value).toFixed(decimals);
};